export default function formatCreatedAt(createdAt: string): string {
  try {
    if (!createdAt) return '';

    const date = new Date(createdAt);
    const now = new Date();

    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      month: '2-digit',
      day: '2-digit',
    });

    const timeFormatter = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    // Check if the given date and current date are the same day
    const isSameDay =
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();

    if (isSameDay) {
      // Same day: Print only the time
      return timeFormatter.format(date).toLowerCase();
    } else {
      // Previous day: Print the date and time
      return `${dateFormatter.format(date)} - ${timeFormatter.format(date)}`.toLowerCase();
    }
  } catch (error) {
    console.log('error', error);
    return '';
  }
}
